import dayjs from '../../../../config/dayjs';

const DATE_FORMAT = 'DD MMM YYYY, hh:mm A';

export const formatDateTime = (value) => (value ? dayjs(value).format(DATE_FORMAT) : '-');

// "LAB-01 / A001", or that the machine was not registered when it asked.
export const seatOf = (request) => (request?.labNo ? `${request.labNo} / ${request.seatNo}` : 'Not registered yet');

export const describeUsbDevice = (device) => [device?.vendor, device?.product].filter(Boolean).join(' ') || `${device?.vendorId}:${device?.productId}`;
